import { ViewChild, ElementRef, AfterViewInit, Renderer2 } from '@angular/core';
import { TrInputComponent } from './../tr-input/tr-input.component';
import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Store } from '@ngrx/store';
import { AppState } from '../../../interfaces/app-state.interface';

@Component({
    selector: "tr-date",
    templateUrl: "./tr-date.component.html",
    styleUrls: ["./tr-date.component.scss"],
})
export class TrDateComponent extends TrInputComponent implements OnInit {
    @ViewChild("formInput", { static: true }) public formInput: ElementRef;

    constructor(
        private datePipe: DatePipe,
        private render: Renderer2,
        store: Store<AppState>
    ) {
        super(store);
    }

    public ngOnInit() {
        super.ngOnInit();
    }

    public getFullDate(): Date {
        const inputDate = this.ValueInput.toString();
        const [day, month, year] = inputDate.split("/");
        const newDateStrig = `${month}/${day}/${year}`;
        return new Date(newDateStrig);
    }

    public setByFullDate(stringDate: string) {
        const date = this.datePipe.transform(stringDate, "dd/MM/yyyy");
        this.ControlReference.setValue(date);
    }
}
